import {apiService} from "../api.service";

export class ForgotPasswordService {
    public async sendEmail(values: {email: string}): Promise<void> {
        await apiService.post("auth/pw_reset/request", {...values});
    }

    public async checkIfComplete(data: {code: string, email: string}): Promise<void> {
        await apiService.post("auth/pw_reset/confirm", {...data})
    }
}

export const forgotPasswordService = new ForgotPasswordService();